import { Col } from "react-bootstrap";
import styled from "styled-components";

export const Subtitle = styled(Col)`
  font-size: 24px;
`;
